import React, { createContext, useContext } from 'react';

type DashboardContextValue = {
  readOnly: boolean;
};

const DashboardContext = createContext<DashboardContextValue>({
  readOnly: false,
});

type DashboardProviderProps = React.PropsWithChildren<{
  readOnly?: boolean;
}>;

export function DashboardProvider({
  readOnly = false,
  children,
}: DashboardProviderProps) {
  return (
    <DashboardContext.Provider value={{ readOnly }}>
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboardContext() {
  return useContext(DashboardContext);
}
